import React, { createContext, useReducer } from 'react';
import { authReducer } from '@reducers/authReducer';
import { loadState } from "@lib/localStorage";
import { useToast } from '@chakra-ui/react';

export const AuthContext = createContext();

const AuthContextProvider = ({ children }) => {

  const setInitialState = () => {
    const user = loadState('user-data');
    const token = loadState('user-access-token');
    if (user && token) return {
      user_data: user,
      token_access: token,
      isLogged: true
    }
    else return {
      user_data: {},
      token_access: "",
      isLogged: false
    };
  };

  const [auth, dispatch] = useReducer(authReducer, setInitialState());
  const toast = useToast();

  return (
    <AuthContext.Provider value={{ auth, dispatch, toast }}>
      {children}
    </AuthContext.Provider>
  );
}
 
export default AuthContextProvider;